var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBateriaHorizontal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "297pt",
    height: "185pt",
    viewBox: "0 0 297 185",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "#d9d9d9ff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "#2767ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2767ff",
    opacity: 1,
    d: " M 23.18 0.00 L 255.23 0.00 C 265.24 2.80 274.32 10.46 275.95 21.15 C 272.27 22.37 268.37 22.48 265.18 20.04 C 262.88 14.41 257.13 10.37 251.02 10.37 C 178.35 10.37 105.68 10.39 33.01 10.36 C 28.41 10.46 23.41 9.67 19.30 12.26 C 15.20 14.11 12.87 18.25 11.38 22.29 C 9.03 20.97 6.36 20.61 3.73 20.39 C 3.31 19.72 2.48 18.37 2.06 17.70 C 5.33 8.44 13.61 1.81 23.18 0.00 Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "#3b5fffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3b5fff",
    opacity: 1,
    d: " M 1.00 35.00 C 1.12 29.24 0.47 23.33 2.06 17.70 C 2.48 18.37 3.31 19.72 3.73 20.39 C 6.36 20.61 9.03 20.97 11.38 22.29 C 10.99 26.53 11.13 30.80 11.13 35.06 C 7.75 35.05 4.38 35.03 1.00 35.00 Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "#3860ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3860ff",
    opacity: 1,
    d: " M 22.96 25.37 C 24.78 22.32 28.46 20.53 31.96 20.49 C 102.99 20.49 174.03 20.50 245.07 20.48 C 249.36 20.14 253.26 23.11 255.27 26.70 C 256.31 29.63 255.90 32.84 256.01 35.89 C 252.59 35.89 249.17 35.89 245.75 35.91 C 245.75 34.19 245.75 32.47 245.75 30.76 C 174.38 30.73 103.01 30.74 31.64 30.75 C 31.63 32.79 31.62 34.83 31.62 36.87 C 28.21 36.85 24.79 36.84 21.38 36.85 C 21.61 33.03 20.52 28.69 22.96 25.37 Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "#405cffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#405cff",
    opacity: 1,
    d: " M 265.18 20.04 C 268.37 22.48 272.27 22.37 275.95 21.15 C 276.93 30.34 276.09 39.60 276.38 48.82 C 273.35 48.85 270.32 48.97 267.29 49.17 C 266.99 52.67 266.59 56.15 266.38 59.65 L 266.29 58.52 C 265.97 48.35 266.22 38.17 266.13 27.99 C 266.07 25.32 265.81 22.64 265.18 20.04 Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "#465bffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#465bff",
    opacity: 1,
    d: " M 1.00 35.00 C 4.38 35.03 7.75 35.05 11.13 35.06 C 11.13 39.02 11.12 42.99 11.12 46.96 C 7.75 47.00 4.38 47.03 1.00 47.05 C 1.00 43.04 1.00 39.02 1.00 35.00 Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "#4759ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4759ff",
    opacity: 1,
    d: " M 245.75 35.91 C 249.17 35.89 252.59 35.89 256.01 35.89 C 256.00 40.96 255.99 46.02 255.99 51.08 C 252.58 51.10 249.16 51.09 245.75 51.08 C 245.75 46.02 245.75 40.97 245.75 35.91 Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "#4a58ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4a58ff",
    opacity: 1,
    d: " M 21.38 36.85 C 24.79 36.84 28.21 36.85 31.62 36.87 C 31.65 43.27 31.61 49.67 31.62 56.07 C 28.21 56.09 24.79 56.09 21.38 56.09 C 21.40 49.68 21.35 43.26 21.38 36.85 Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "#5056ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5056ff",
    opacity: 1,
    d: " M 1.00 47.05 C 4.38 47.03 7.75 47.00 11.12 46.96 C 11.13 50.96 11.13 54.96 11.13 58.96 C 7.75 58.95 4.38 58.94 1.00 58.93 C 1.00 54.97 1.00 51.01 1.00 47.05 Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "#5753ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5753ff",
    opacity: 1,
    d: " M 267.29 49.17 C 270.32 48.97 273.35 48.85 276.38 48.82 C 276.39 49.38 276.39 50.49 276.39 51.05 C 279.47 51.12 282.59 50.96 285.62 51.59 C 291.34 53.35 295.72 58.54 296.70 64.44 C 296.37 67.91 296.03 71.38 296.07 74.87 C 292.92 74.83 289.77 74.82 286.63 74.82 C 286.66 71.42 286.60 68.01 286.54 64.61 C 285.50 63.57 284.48 62.52 283.46 61.46 C 281.10 61.42 278.74 61.39 276.39 61.36 C 276.37 65.88 276.36 70.40 276.37 74.93 C 273.37 74.87 270.36 74.72 267.36 74.65 C 266.84 69.66 266.77 64.65 266.38 59.65 C 266.59 56.15 266.99 52.67 267.29 49.17 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5753ff",
    opacity: 1,
    d: " M 245.75 51.08 C 249.16 51.09 252.58 51.10 255.99 51.08 C 256.01 57.07 256.00 63.06 256.00 69.04 C 252.58 68.98 249.17 68.95 245.75 68.93 C 245.75 62.98 245.74 57.03 245.75 51.08 Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "#0fbb00ff"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "#5a51ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5a51ff",
    opacity: 1,
    d: " M 21.38 56.09 C 24.79 56.09 28.21 56.09 31.62 56.07 C 31.63 61.69 31.62 67.32 31.62 72.94 C 28.21 73.02 24.79 73.09 21.38 73.15 C 21.39 67.46 21.35 61.78 21.38 56.09 Z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "#5b51ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5b51ff",
    opacity: 1,
    d: " M 1.00 58.93 C 4.38 58.94 7.75 58.95 11.13 58.96 C 11.13 63.29 11.12 67.62 11.12 71.96 C 7.75 71.94 4.38 71.94 1.00 71.96 C 1.00 67.62 1.00 63.27 1.00 58.93 Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "#6b4affff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6b4aff",
    opacity: 1,
    d: " M 266.29 58.52 L 266.38 59.65 C 266.77 64.65 266.84 69.66 267.36 74.65 C 270.36 74.72 273.37 74.87 276.37 74.93 C 276.38 80.64 276.37 86.36 276.38 92.08 C 272.96 92.09 269.54 92.08 266.13 92.05 C 266.22 80.87 265.90 69.69 266.29 58.52 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b4aff",
    opacity: 1,
    d: " M 286.63 74.82 C 289.77 74.82 292.92 74.83 296.07 74.87 C 296.13 80.57 296.03 86.28 296.00 91.98 C 292.87 92.04 289.75 92.08 286.63 92.11 C 286.62 86.35 286.61 80.59 286.63 74.82 Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "#8c6df6ff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8c6df6",
    opacity: 1,
    d: " M 296.70 64.44 L 297.00 66.05 L 297.00 115.51 C 296.49 116.51 295.96 117.50 295.42 118.49 C 295.67 115.71 295.78 112.93 295.92 110.15 C 296.17 104.10 295.98 98.04 296.00 91.98 C 296.03 86.28 296.13 80.57 296.07 74.87 C 296.03 71.38 296.37 67.91 296.70 64.44 Z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "#654dffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#654dff",
    opacity: 1,
    d: " M 245.75 68.93 C 249.17 68.95 252.58 68.98 256.00 69.04 C 256.00 74.68 256.00 80.31 255.99 85.94 C 252.58 86.01 249.16 86.04 245.75 86.04 C 245.75 80.34 245.74 74.64 245.75 68.93 Z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "#674cffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#674cff",
    opacity: 1,
    d: " M 1.00 71.96 C 4.38 71.94 7.75 71.94 11.12 71.96 C 11.12 76.67 11.12 81.38 11.13 86.09 C 7.75 86.08 4.38 86.06 1.00 86.02 C 1.01 81.33 1.00 76.65 1.00 71.96 Z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "#6a4bffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6a4bff",
    opacity: 1,
    d: " M 21.38 73.15 C 24.79 73.09 28.21 73.02 31.62 72.94 C 31.64 79.32 31.62 85.70 31.62 92.08 C 28.21 91.99 24.79 91.93 21.38 91.87 C 21.38 85.63 21.35 79.39 21.38 73.15 Z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "#7446ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7446ff",
    opacity: 1,
    d: " M 1.00 86.02 C 4.38 86.06 7.75 86.08 11.13 86.09 C 11.12 91.04 11.13 96.00 11.13 100.95 C 7.75 100.96 4.38 100.98 1.00 101.02 C 1.00 96.02 1.00 91.02 1.00 86.02 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7446ff",
    opacity: 1,
    d: " M 245.75 86.04 C 249.16 86.04 252.58 86.01 255.99 85.94 C 256.00 90.93 256.00 95.92 256.00 100.91 C 252.58 100.99 249.16 101.05 245.75 101.10 C 245.75 96.08 245.75 91.06 245.75 86.04 Z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "#7a43ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7a43ff",
    opacity: 1,
    d: " M 21.38 91.87 C 24.79 91.93 28.21 91.99 31.62 92.08 C 31.64 98.41 31.62 104.75 31.62 111.08 C 28.21 111.10 24.79 111.10 21.38 111.10 C 21.38 104.69 21.36 98.28 21.38 91.87 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7a43ff",
    opacity: 1,
    d: " M 266.13 92.05 C 269.54 92.08 272.96 92.09 276.38 92.08 C 276.38 98.07 276.37 104.07 276.37 110.06 C 273.34 110.10 270.31 110.24 267.29 110.30 C 266.76 115.34 266.81 120.40 266.40 125.44 L 266.32 126.62 C 265.94 115.10 266.21 103.57 266.13 92.05 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7a43ff",
    opacity: 1,
    d: " M 286.63 92.11 C 289.75 92.08 292.87 92.04 296.00 91.98 C 295.98 98.04 296.17 104.10 295.92 110.15 C 292.81 110.15 289.71 110.13 286.61 110.10 C 286.67 104.10 286.60 98.11 286.63 92.11 Z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "#8041ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8041ff",
    opacity: 1,
    d: " M 1.00 101.02 C 4.38 100.98 7.75 100.96 11.13 100.95 C 11.12 105.32 11.12 109.69 11.13 114.06 C 7.75 114.03 4.38 114.00 1.00 113.96 C 1.00 109.65 1.00 105.33 1.00 101.02 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8041ff",
    opacity: 1,
    d: " M 245.75 101.10 C 249.16 101.05 252.58 100.99 256.00 100.91 C 256.00 105.30 256.00 109.68 256.00 114.07 C 252.58 114.08 249.16 114.08 245.75 114.07 C 245.75 109.75 245.75 105.43 245.75 101.10 Z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "#8c3cffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8c3cff",
    opacity: 1,
    d: " M 267.29 110.30 C 270.31 110.24 273.34 110.10 276.37 110.06 C 276.37 112.55 276.39 115.03 276.41 117.52 C 278.67 117.49 280.94 117.48 283.21 117.47 C 284.29 116.45 285.39 115.45 286.50 114.46 C 286.54 113.01 286.57 111.55 286.61 110.10 C 289.71 110.13 292.81 110.15 295.92 110.15 C 295.78 112.93 295.67 115.71 295.42 118.49 C 292.37 125.91 283.84 128.66 276.40 127.65 C 276.38 131.39 276.36 135.13 276.37 138.87 C 273.41 138.81 270.45 138.66 267.49 138.59 C 267.10 134.21 266.71 129.83 266.40 125.44 C 266.81 120.40 266.76 115.34 267.29 110.30 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c3cff",
    opacity: 1,
    d: " M 245.75 114.07 C 249.16 114.08 252.58 114.08 256.00 114.07 C 256.00 119.41 256.00 124.76 256.00 130.10 C 252.58 130.05 249.16 130.00 245.75 129.93 C 245.75 124.64 245.75 119.36 245.75 114.07 Z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "#8b3dffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8b3dff",
    opacity: 1,
    d: " M 21.38 111.10 C 24.79 111.10 28.21 111.10 31.62 111.08 C 31.64 117.07 31.62 123.07 31.63 129.06 C 28.21 128.99 24.79 128.95 21.37 128.91 C 21.36 122.97 21.37 117.04 21.38 111.10 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8b3dff",
    opacity: 1,
    d: " M 1.00 113.96 C 4.38 114.00 7.75 114.03 11.13 114.06 C 11.13 118.03 11.13 122.00 11.12 125.96 C 7.75 125.96 4.37 125.96 1.00 125.96 C 1.00 121.96 1.00 117.96 1.00 113.96 Z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "#9538ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9538ff",
    opacity: 1,
    d: " M 1.00 125.96 C 4.37 125.96 7.75 125.96 11.12 125.96 C 11.12 130.00 11.12 134.04 11.12 138.08 C 7.75 138.08 4.38 138.07 1.00 138.06 C 1.00 134.02 1.00 129.99 1.00 125.96 Z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "#a232ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a232ff",
    opacity: 1,
    d: " M 266.32 126.62 L 266.40 125.44 C 266.71 129.83 267.10 134.21 267.49 138.59 C 270.45 138.66 273.41 138.81 276.37 138.87 C 276.37 144.66 276.36 150.46 276.42 156.25 C 273.51 156.32 270.61 156.48 267.71 156.53 C 267.18 157.77 266.63 159.01 266.13 160.27 C 266.26 149.05 265.87 137.83 266.32 126.62 Z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "#9b36ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9b36ff",
    opacity: 1,
    d: " M 21.37 128.91 C 24.79 128.95 28.21 128.99 31.63 129.06 C 31.63 135.04 31.63 141.01 31.61 146.99 C 28.20 147.08 24.79 147.13 21.38 147.17 C 21.36 141.08 21.37 135.00 21.37 128.91 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9b36ff",
    opacity: 1,
    d: " M 245.75 129.93 C 249.16 130.00 252.58 130.05 256.00 130.10 C 256.00 135.79 256.00 141.47 256.00 147.16 C 252.59 147.16 249.17 147.14 245.75 147.10 C 245.74 141.37 245.75 135.65 245.75 129.93 Z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "#a033ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a033ff",
    opacity: 1,
    d: " M 1.00 138.06 C 4.38 138.07 7.75 138.08 11.12 138.08 C 11.12 142.74 11.15 147.39 11.10 152.05 C 7.73 152.06 4.36 152.06 0.99 152.05 C 1.01 147.39 1.00 142.72 1.00 138.06 Z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "#ab2effff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ab2eff",
    opacity: 1,
    d: " M 21.38 147.17 C 24.79 147.13 28.20 147.08 31.61 146.99 C 31.62 149.04 31.67 151.10 31.69 153.15 C 103.04 153.10 174.39 153.14 245.75 153.13 C 245.74 151.12 245.75 149.11 245.75 147.10 C 249.17 147.14 252.59 147.16 256.00 147.16 C 255.95 150.33 256.27 153.58 255.47 156.68 C 253.71 160.76 249.48 163.62 244.98 163.38 C 173.96 163.38 102.93 163.38 31.91 163.38 C 28.60 163.27 24.95 161.90 23.22 158.91 C 20.47 155.60 21.58 151.10 21.38 147.17 Z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "#ad2effff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ad2eff",
    opacity: 1,
    d: " M 0.99 152.05 C 4.36 152.06 7.73 152.06 11.10 152.05 C 11.16 156.51 10.60 161.29 12.94 165.32 C 9.43 165.65 5.88 166.20 2.71 167.84 C 0.63 162.84 1.00 157.34 0.99 152.05 Z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "#bd26ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bd26ff",
    opacity: 1,
    d: " M 267.71 156.53 C 270.61 156.48 273.51 156.32 276.42 156.25 C 276.41 162.22 275.19 168.48 271.43 173.27 C 266.79 179.69 258.98 183.83 251.04 183.76 C 178.69 183.75 106.34 183.75 33.99 183.75 C 30.02 183.72 26.04 183.96 22.09 183.48 C 13.51 181.89 6.14 175.85 2.71 167.84 C 5.88 166.20 9.43 165.65 12.94 165.32 C 15.63 170.39 21.25 173.71 26.97 173.64 C 98.99 173.61 171.01 173.63 243.03 173.63 C 248.23 173.55 253.91 174.42 258.50 171.37 C 262.88 169.32 265.09 164.75 266.13 160.27 C 266.63 159.01 267.18 157.77 267.71 156.53 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBateriaHorizontal);
export default __webpack_public_path__ + "static/media/bateria-horizontal.91dd3f4b8031a1bc357ef187c935e96c.svg";
export { ForwardRef as ReactComponent };